import React, { useState } from "react";
import "./FAQ.css";

export interface FAQItem {
  question: string;
  answer: string;
}

export interface FAQProps {
  faqs: FAQItem[];
  title?: string;
}

const FAQSection: React.FC<FAQProps> = ({ faqs, title = "Հաճախ տրվող հարցեր" }) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-section">
      <h2 className="faq-title">{title}</h2>
      <div className="faq-list">
        {faqs.map((item, idx) => (
          <div key={idx} className="faq-item">
            <button
              className="faq-question"
              onClick={() => toggleFAQ(idx)}
              aria-expanded={openIndex === idx}
            >
              <span>{item.question}</span>
              <span className="faq-icon">+</span>
            </button>
            {openIndex === idx && (
              <div className="faq-answer">{item.answer}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQSection;
